import { useNavigate } from "react-router-dom";
import Footer from "../../core/common/footer/Footer";
import bulbImage from "../../images/buld.png";
import Swal from "sweetalert2";
import useApi from "../../core/customhook/useApi";
import { useSelector } from "react-redux";
import { RootState } from "../../core/data/redux/store";
import { useState } from "react";
import { all_routes } from "../router/all_routes";
import ESignaturePad from "../Address/components/ESignaturePad";

const AuthorizationForm = () => {
  const navigate = useNavigate();
  const assignment_id = useSelector(
    (state: RootState) => state?.package?.assignment_id,
  );

  const packageStatus = useSelector(
    (state: RootState) => state?.package?.status,
  );

  const packageinfo = useSelector(
    (state: RootState) => state?.package?.templates,
  );

  const [isDeclarationChecked, setIsDeclarationChecked] = useState(true);
  const [signature, setSignature] = useState<File | null>(null);

  // const reduxDashboardData = useSelector(
  //   (state: any) => state?.dashboard?.dashboardData,
  // );

  // const candidateId = reduxDashboardData?.assignmentDetails?.candidate_id;

  // const getAddressAPI = useApi<any>(
  //   `/api/v1/candidates/addresses/${candidateId}`,
  //   {
  //     method: "GET",
  //     autoCall: false,
  //     handleGlobalError: false,
  //   },
  // );

  // const [addressStatus, setAddressStatus] = useState("");

  // const fetchDetails = async () => {
  //   try {
  //     const res = await getAddressAPI.callApi();

  //     if (!res?.success) return;

  //     const address = res.data[0];

  //     setAddressStatus(address?.status);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // useEffect(() => {
  //   if (candidateId) {
  //     fetchDetails();
  //   }
  // }, [candidateId]);

  const templateSubmitAPI = useApi<any>(
    `/api/v1/candidate/packages/${assignment_id}/submit`,
    {
      method: "POST",
      autoCall: false,
      handleGlobalError: false,
    },
  );

  const handleSignatureChange = (_: string, file: File | null) => {
    setSignature(file);
  };

  const ALLOWED_CHECK_IDS = [
    "76626fce-8141-4106-86d2-6c1e274adae9", // Aadhar KYC
    "a687f91f-1c4c-4761-a4fe-37a564887783", // Highest Education
    "550f294a-257d-4b87-a0e7-8b34a3223d41", // 2 Highest Education
    "1d479262-b776-4bb5-8e52-3a6919556f5d", // Education Documents
    "66b2e258-615e-4998-b51b-b8b7ec5a2417", // All Education Documents
    "b225216b-ec67-4b70-a4f0-61ce4460b8bb", // Employement
    "1f12f689-b17a-409b-b433-bc7d685ca84f", // Employement 2 YEAR
    "2c825e1d-10d2-4caf-b12d-b1df9c21b806", // Employement 3 YEAR
    "1eda7972-29b4-40d4-a688-44a3afc2c360", // Employement 5 YEAR
    "d904e066-1c35-4525-b971-7aaaa8cbde44", // Employement 7 YEAR
    "a0057787-887b-4d45-9da3-5a758e4b6964", // Employement 10 YEAR
    "8ff47bc3-a23c-455a-9970-4fff6a685edd", // Pancard
    "12c919a4-0f58-404a-b147-5a8aea9ab00b", // PAN card verification (without validation)
    "39f7eec6-874a-48d8-8c16-4c682269631c", // Career Gap Comments
    "a65ad58f-7e33-4caf-b289-40520159d251", // Reference
  ];

  const ADDRESS_CHECK_ID = "9a6fd659-63ad-4d92-ad3c-ab5bff7bb86d";

  const handleSubmitDocument = async () => {
    try {
      // 1. Check CV Upload Status
      const userPersonalData = JSON.parse(
        localStorage.getItem("userPersonalData") || "{}",
      );

      if (
        userPersonalData?.resume_file_key === null ||
        !userPersonalData?.resume_file_key
      ) {
        Swal.fire({
          icon: "warning",
          title: "CV Required",
          text: "Please Upload CV in Personal Information",
        });
        return;
      }

      const addressCheck = packageinfo?.find(
        (item: any) => item.check_id === ADDRESS_CHECK_ID,
      );

      // Apply condition ONLY if Address Check exists
      if (addressCheck && addressCheck.status !== "CANDIDATE_SUBMITTED") {
        Swal.fire({
          icon: "warning",
          title: "Address Verification Pending",
          text: "Please complete and submit your Address Check before submitting the application.",
        });
        return;
      }

      // 2. Validate all other allowed checks
      const pendingTemplate = packageinfo?.find(
        (item: any) =>
          item.check_id !== ADDRESS_CHECK_ID &&
          ALLOWED_CHECK_IDS.includes(item.check_id) &&
          item.status !== "CANDIDATE_IN_PROGRESS",
      );

      if (pendingTemplate) {
        Swal.fire({
          icon: "warning",
          title: "Pending Verification",
          text: `${pendingTemplate.check_name} is pending to submit. Please complete it before submitting the application.`,
        });
        return;
      }

      if (!isDeclarationChecked) {
        Swal.fire({
          icon: "warning",
          title: "Declaration Required",
          text: "Please accept the declaration before submitting.",
        });
        return;
      }

      // Signature validation
      if (!signature) {
        Swal.fire({
          icon: "warning",
          title: "Signature Required",
          text: "Please upload your signature before submitting.",
        });
        return;
      }

      // Confirmation
      const confirmation = await Swal.fire({
        icon: "warning",
        title: "Confirm Submission",
        html: `
        <p>Are you sure you want to submit this form?</p>
        <p style="color:red">
          After submission you will not be able to edit your information.
        </p>
      `,
        showCancelButton: true,
        confirmButtonText: "Yes, Submit",
        cancelButtonText: "Cancel",
        reverseButtons: true,
      });

      if (!confirmation.isConfirmed) return;

      const formData = new FormData();

      if (signature) {
        formData.append("signatureUrl", signature);
      }

      // formData.forEach((value, key) => {
      //   console.log(key, value);
      // });

      const response = await templateSubmitAPI.callApi(formData);

      if (response?.success) {
        await Swal.fire({
          icon: "success",
          title: "Submitted Successfully",
          text: response?.message || "Document submitted successfully",
        });

        navigate(all_routes.caseSummary);
      } else {
        Swal.fire({
          icon: "error",
          title: "Submit Failed",
          text: response?.message || "Something went wrong",
        });
      }
    } catch (error: any) {
      Swal.fire({
        icon: "error",
        title: "Submit Failed",
        text:
          error?.response?.data?.error ||
          error?.message ||
          "Something went wrong",
      });
    }
  };

  // signatureUrl

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-8">
              <div className="card overflow-hidden p-4">
                {/* Heading */}
                <h2
                  className="text-center fw-bold mb-4"
                  style={{
                    fontSize: "22px",
                  }}
                >
                  Letter of Authorization (Consent Form)
                </h2>

                {/* Content Box */}
                <div
                  className="p-4 mb-4"
                  style={{
                    border: "1px solid #d9d9d9",
                    borderRadius: "4px",
                  }}
                >
                  <h4
                    className="fw-bold mb-3"
                    style={{
                      fontSize: "20px",
                    }}
                  >
                    Candidate Authorization
                  </h4>

                  <p
                    style={{
                      fontSize: "16px",
                      lineHeight: "30px",
                      color: "#222",
                    }}
                  >
                    I hereby authorize Aupertz Services Private Limited, and/or
                    any of its affiliates acting on its behalf, to verify all
                    the information/data/credentials filled in and reproduced in
                    this Candidate Declaration Form (CDF), for procurement of
                    Investigation/Verification Report.
                  </p>

                  <p
                    className="mb-0"
                    style={{
                      fontSize: "16px",
                      lineHeight: "30px",
                      color: "#222",
                    }}
                  >
                    I hereby give my consent and authorize to the bearer of this
                    CDF to access and verify my previous records and
                    information, I further expressly accord my consent,
                    indemnify and hold harmless Aupertz Services Private
                    Limited, its Directors, officers, shareholders, affiliates
                    and all the persons/entities/ organizations/persons acting
                    on its behalf in this regard form any liability whatsoever
                    in connection with the investigation/verification activity.
                  </p>
                </div>

                {/* view there pre filled details readonly  */}

                {[
                  "SUBMITED",
                  "INSUFF",
                  "WORK IN PROGRESS",
                  "VERIFIED",
                  "CANCELLED",
                ].includes(packageStatus) ? (
                  <p className="text-danger">
                    This Applicant Declaration Form is Already Submitted
                  </p>
                ) : (
                  <div className="border rounded-3 p-4 bg-light-subtle">
                    {/* Heading */}
                    <div className="mb-4">
                      <h5 className="fw-bold mb-1">Declaration</h5>
                      <p className="text-muted mb-0">
                        Please review the declaration carefully before
                        submitting your application.
                      </p>
                    </div>

                    {/* Declaration */}
                    <div className="d-flex align-items-start gap-3 p-3 border rounded-3 bg-white mb-4">
                      <input
                        type="checkbox"
                        checked={isDeclarationChecked}
                        onChange={(e) =>
                          setIsDeclarationChecked(e.target.checked)
                        }
                        style={{
                          width: 22,
                          height: 22,
                          cursor: "pointer",
                          marginTop: 3,
                          flexShrink: 0,
                        }}
                      />

                      <label
                        className="mb-0 text-secondary"
                        style={{
                          fontSize: 15,
                          lineHeight: "28px",
                          cursor: "pointer",
                        }}
                      >
                        I have read, understood, and consent to the statements
                        listed above. I also consent to undertake the
                        verification services as proposed.
                      </label>
                    </div>

                    {/* Signature */}
                    <div className="mb-4">
                      <label className="form-label fw-semibold">
                        E-Signature <span className="text-danger">*</span>
                      </label>

                      <ESignaturePad
                        field="signature"
                        onChange={handleSignatureChange}
                        // existingSignatureUrl={null}
                        // error={errors.applicant_sign}
                      />
                    </div>

                    {/* Submit */}
                    <div className="d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn btn-primary px-4"
                        onClick={handleSubmitDocument}
                        disabled={templateSubmitAPI.loading}
                      >
                        {templateSubmitAPI.loading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Submitting...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-floppy me-2"></i>
                            Submit Application
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="col-md-4">
              <div
                style={{
                  position: "sticky",
                  top: "60px",
                  alignSelf: "flex-start",
                }}
              >
                <div className="card border-0 shadow-sm">
                  {/* Header */}
                  <div
                    className="text-center py-4"
                    style={{ backgroundColor: "#f7f1e3" }}
                  >
                    <div
                      className="d-flex align-items-center justify-content-center mx-auto mb-2 rounded-circle bg-white"
                      style={{ width: "70px", height: "70px" }}
                    >
                      {/* <i
                      className="bi bi-lightbulb-fill text-warning"
                      style={{ fontSize: "35px" }}
                    ></i> */}
                      <img src={bulbImage} alt="buld" />
                    </div>

                    <h6 className="fw-bold mb-0">Instructions</h6>
                  </div>

                  {/* Body */}
                  <div className="card-body">
                    {/* Instruction 1 */}
                    <div className="d-flex mb-4">
                      <div
                        className="rounded me-3 mt-1 flex-shrink-0"
                        style={{
                          width: "16px",
                          height: "16px",
                          backgroundColor: "#f4c542",
                        }}
                      ></div>

                      <div>
                        <h6 className="mb-1 fw-semibold">Instruction 1</h6>

                        <p className="text-muted mb-0 small">
                          <b>
                            Please provide your consent by digitally signing
                            online
                          </b>
                        </p>
                      </div>
                    </div>

                    {/* Instruction 2 */}
                    <div className="d-flex mb-4">
                      <div
                        className="rounded me-3 mt-1 flex-shrink-0"
                        style={{
                          width: "16px",
                          height: "16px",
                          backgroundColor: "#f4c542",
                        }}
                      ></div>
                      <div>
                        <h6 className="mb-1 fw-semibold">Instruction 2</h6>

                        <p className="text-muted mb-0 small">
                          You can also give feedback on our service
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default AuthorizationForm;
